import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getUserAttendHistory } from '../../../api/user';
import { errorMessages, formatDate } from '../../../utils/methods';
import { useToast } from 'use-toast-mui';
import QueryString from 'qs';
import CommonLoading from '../../../form-components/CommonLoading';
import CommonPagination from '../../../form-components/CommonPagination';
const initialQuery = {
  page: 1,
  limit: 10,
};

export default function UserAttend({ user, bigUser, active }) {
  const toast = useToast();
  // 다지점 회원은 지점을 안 보내면 타 지점 출석까지 섞여 나온다.
  // 지점 계정은 그 지점만, 헤드 계정은 소속 지점 전체를 본다(백엔드가 같은 규칙으로 판정).
  const [query, setQuery] = useState({
    ...initialQuery,
    memberId: user.memberId,
    branchId: bigUser?.branch?.branchId,
    headBranchId: bigUser?.headBranch?.headBranchId,
  });
  const [attendHistory, setAttendHistory] = useState();
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  const handleChangePage = (event, value) => {
    setQuery({ ...query, page: value });
  };

  const getAttendHistory = async () => {
    const queryString = QueryString.stringify(query);
    try {
      const data = await getUserAttendHistory(queryString, bigUser.token);
      setAttendHistory(data);
    } catch (error) {
      toast.error(errorMessages(error));
    } finally {
      setIsInitialLoading(false);
    }
  };

  useEffect(() => {
    getAttendHistory();
  }, [query, active]);

  const switchAttend = attendType => {
    switch (attendType) {
      case 'I':
        return '입장';
      case 'O':
        return '퇴장';
      case 'B':
        return '거절';
      default:
        return '-';
    }
  };

  // 첫 진입 시 빈 테이블이 잠깐 보이는 것을 막는다.
  if (isInitialLoading) {
    return <CommonLoading minHeight={420} />;
  }

  return (
    <>
      <Typography variant="h6" className="title" sx={{ mt: '30px', mb: '10px' }}></Typography>
      <TableContainer
        sx={{
          border: '1px solid #ddd',
          borderRadius: '5px',
        }}>
        <Table
          sx={{
            minWidth: 650,
            '.css-1vhoxdy-MuiTableCell-root': { padding: '1px' },
          }}
          size="small"
          aria-label="a dense table">
          <TableHead sx={{ background: '#FAFBFC' }}>
            <TableRow sx={{ height: '40px' }}>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid #ddd',
                  fontSize: '12px',
                  fontWeight: 550,
                }}>
                지점 명
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid #ddd',
                  fontSize: '12px',
                  fontWeight: 550,
                }}>
                상태
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid #ddd',
                  fontSize: '12px',
                  fontWeight: 550,
                }}>
                이용날짜
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid #ddd',
                  fontSize: '12px',
                  fontWeight: 550,
                }}>
                입장시간
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  borderRight: '1px solid #ddd',
                  fontSize: '12px',
                  fontWeight: 550,
                }}>
                입장횟수
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attendHistory &&
              attendHistory.content.map((attendHistory, index) => (
                <TableRow
                  key={index}
                  sx={{
                    height: '40px',
                    '&:last-child td, &:last-child th': { borderBottom: 0 },
                  }}>
                  <TableCell align="center" component="th" scope="row" sx={{ borderRight: '1px solid #ddd' }}>
                    {attendHistory.branchName}
                  </TableCell>
                  <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                    {switchAttend(attendHistory.attendType)}
                  </TableCell>
                  <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                    {attendHistory.writeDate ? formatDate(attendHistory.writeDate, 'YYYY-MM-DD (dd)') : '-'}
                  </TableCell>
                  <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                    {attendHistory.startTime ? attendHistory.startTime : '-'}
                  </TableCell>
                  <TableCell align="center" sx={{ borderRight: '1px solid #ddd' }}>
                    {attendHistory.attendCount ? attendHistory.attendCount : '-'}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <CommonPagination
        totalElements={attendHistory?.totalElements}
        limit={attendHistory?.size}
        page={query.page}
        onChange={handleChangePage}
      />
    </>
  );
}
